import { observable, computed } from "mobx";
import {
  GameReleaseEntity,
  GameEntity,
  ArchiveInfo,
  MapInfo,
  ReleaseLanguageDto,
  GameReleaseEntityReleaseStatusEnum,
} from "@citychallenge/api-public";
import { Translation, TransTokens } from "../i18n";

const transTokens = TransTokens.create({
  english: "English",
});

interface GameEntityWithId extends GameEntity {
  id: string;
}

export class GameReleaseModel implements GameReleaseEntity {
  public entityType = "GameReleaseModel";

  constructor(entity: GameReleaseEntity, game: GameEntityWithId) {
    Object.assign(this, entity);

    if (game) this.game = game;

    // Download URL/bundle path are empty.
    // They are requested when a release download is started
    this.downloadUrl = "";
    this.bundlePath = "";
  }

  @observable
  public id!: string;

  @observable
  public releaseVersion!: number;

  @observable
  public created?: any;

  @observable
  public game!: GameEntityWithId;

  @observable
  public downloadUrl: string;

  @observable
  public bundlePath: string;

  @observable
  public archiveInfo?: ArchiveInfo;

  @observable
  public maps?: Array<MapInfo>;

  @observable
  public releaseStatus?: GameReleaseEntityReleaseStatusEnum;

  @observable
  public appVersionBuilt?: string;

  @observable
  public appVersionAutoChecked?: string;

  @observable
  public mapSize?: number;

  @observable
  public appVersionVerified?: string;

  @observable
  public containsAr!: boolean;

  @observable
  public containsVr!: boolean;

  @observable
  public containsGps!: boolean;

  @observable
  public containsMagneto!: boolean;

  @observable
  public containsCamera!: boolean;

  @observable
  public languages?: ReleaseLanguageDto[];

  @observable
  public supportsDynamicDownloads!: boolean;

  @computed
  public get transLanguages(): (Translation | string)[] {
    const tokens: (Translation | string)[] = [];

    const languages = this.languages || [];

    for (const { name } of languages) {
      tokens.push(TransTokens.getTranslation(name));
      tokens.push(", ");
    }

    if (!tokens.length) tokens.push(transTokens.english);
    else tokens.pop(); // Pop the last ", "

    return tokens;
  }

  @computed
  public get hasRequirements() {
    return (
      this.containsAr ||
      this.containsAr ||
      this.containsGps ||
      this.containsMagneto ||
      this.containsMagneto
    );
  }

  // TODO: We patched this thing the hacky way to fix circular JSON structure
  // Very ugly indeed
  public toJSON() {
    const obj = { ...this };
    const game = { ...obj.game };
    delete game.release;

    obj.game = game as any;
    return obj;
  }
}
